import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selections: [],
    isLoading: false,
    themes: [],
    themesByKey: {},
    themeSelections: {},
    appliedConsumerFilters: [],
    missingConsumerFilters: [],
    filterAcrossEnabled: false,
    // Persisted across navigation to Respondent Module so filters and products are restored on Back
    rowStates: {},
    localConsumerFilters: {},
    productsByVariable: {},
    variableTabs: [],
    activeVariableId: "",
};

const flattenThemesByKey = (themesByKey) => Object.values(themesByKey).flat();

export const textThemeSlice = createSlice({
    name: "textThemeStore",
    initialState,
    reducers: {
        toggleTextThemeSelection: (state, action) => {
            state.selections = action.payload;
        },
        clearTextThemeSelections: (state) => {
            state.selections = [];
            state.themes = [];
            state.themesByKey = {};
            state.themeSelections = {};
            state.appliedConsumerFilters = [];
            state.missingConsumerFilters = [];
            state.filterAcrossEnabled = false;
            // Also clear the persisted filter/product state when leaving TTA entirely
            state.rowStates = {};
            state.localConsumerFilters = {};
            state.productsByVariable = {};
            state.variableTabs = [];
            state.activeVariableId = "";
        },
        setConsumerFilters: (state, action) => {
            state.appliedConsumerFilters = action.payload.applied || [];
            state.missingConsumerFilters = action.payload.missing || [];
        },
        setFilterAcrossEnabled: (state, action) => {
            state.filterAcrossEnabled = action.payload;
        },
        setTextThemeIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setThemes: (state, action) => {
            state.themes = action.payload;
        },
        setThemesByKey: (state, action) => {
            state.themesByKey = action.payload || {};
            state.themes = flattenThemesByKey(state.themesByKey);
        },
        updateThemesByKey: (state, action) => {
            state.themesByKey = { ...state.themesByKey, ...(action.payload || {}) };
            state.themes = flattenThemesByKey(state.themesByKey);
        },
        setThemeSelections: (state, action) => {
            state.themeSelections = action.payload;
        },
        updateThemeSelection: (state, action) => {
            const { productId, selections } = action.payload;
            state.themeSelections[productId] = selections;
        },
        // Save card-filter UI state and product data so it can be restored after navigating back from Respondent Module
        saveFilterState: (state, action) => {
            state.rowStates = action.payload.rowStates || {};
            state.localConsumerFilters = action.payload.localConsumerFilters || {};
            if (action.payload.productsByVariable !== undefined) {
                state.productsByVariable = action.payload.productsByVariable;
                state.variableTabs = action.payload.variableTabs || [];
                state.activeVariableId = action.payload.activeVariableId || "";
            }
        },
    },
});

export const {
    toggleTextThemeSelection,
    clearTextThemeSelections,
    setTextThemeIsLoading,
    setThemes,
    setThemesByKey,
    updateThemesByKey,
    setThemeSelections,
    updateThemeSelection,
    setConsumerFilters,
    setFilterAcrossEnabled,
    saveFilterState,
} = textThemeSlice.actions;

export default textThemeSlice.reducer;